//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import ContentSourceType from '@models/ContentSourceType';
import IContentMedia from '@models/IContentMedia';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import InstagramHashtag from '@models/InstagramHashtag';
import InstagramUserId from '@models/InstagramUserId';
import { buildCustomDateRangeString } from '@utils/dateUtils';

export enum ContentFilterSort {
  Time = 'time',
  Engagement = 'engagement',
  Likes = 'likes',
  Comments = 'comments',
  VisualScore = 'visualScore',
  EMV = 'emv',
}

export enum ContentFilterState {
  Any = 'any',
  All = 'all',
}

export const getContentDetailFilterDateRange = (
  startDate: Date,
  endDate: Date,
) => buildCustomDateRangeString(startDate, endDate, '_');

export interface IContentDetailMediaRequest {
  source: ContentSourceType;
  id?: InstagramUserId | InstagramBusinessAccountId | InstagramHashtag;
  name?: string;
  limit?: number;
  offset?: number;

  // Reporting params
  reporting?: boolean;
  aggregations?: boolean;
  nextMaxId?: string;

  // Filter params
  f_dr?: string; // Formatted as startDate_endDate, with dates represented as YYYY-MM-DD
  f_mentions?: boolean;
  f_sort?: ContentFilterSort;
  f_state?: ContentFilterState;
  f_hashtags?: string; // Formatted as "hashtag1,hashtag2"
  f_users?: string; // Formatted as "username1,username2"

}

/**
 * This is an incomplete typing of this response shape. If you add a
 * new usage of this, please add typing information.
 */
export interface IContentDetailMediaResponse {
  media: IContentMedia[];
}
